import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { CompanyProvider } from "@/contexts/CompanyContext";
import { ViewModeProvider } from "@/contexts/ViewModeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import LoginPage from "@/pages/LoginPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import LandingPage from "@/pages/LandingPage";
import DashboardPage from "@/pages/DashboardPage";
import CompaniesPage from "@/pages/CompaniesPage";
import SectorsPage from "@/pages/SectorsPage";
import EmployeesPage from "@/pages/EmployeesPage";
import EmployeeLeavesPage from "@/pages/EmployeeLeavesPage";
import JobPlansPage from "@/pages/JobPlansPage";
import CargosSalariosPage from "@/pages/CargosSalariosPage";
import SchedulesPage from "@/pages/SchedulesPage";
import RecruitmentPage from "@/pages/RecruitmentPage";
import TrainingsPage from "@/pages/TrainingsPage";
import TerminationsPage from "@/pages/TerminationsPage";
import AuditPage from "@/pages/AuditPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import ImportEmployeesPage from "@/pages/ImportEmployeesPage";
import SpecificImportPage from "@/pages/SpecificImportPage";
import PermissionsMatrixPage from "@/pages/PermissionsMatrixPage";
import AdminBlocksPage from "@/pages/AdminBlocksPage";
import AiReportsPage from "@/pages/AiReportsPage";
import GestaoPage from "@/pages/GestaoPage";
import SetoresEQuadroPage from "@/pages/SetoresEQuadroPage";
import AdminCleanupPage from "@/pages/AdminCleanupPage";
import GroupDashboardPage from "@/pages/GroupDashboardPage";
import GoalsAdminPage from "@/pages/GoalsAdminPage";
import BulkManagementPage from "@/pages/BulkManagementPage";
import BulkHistoryPage from "@/pages/BulkHistoryPage";
import ApprovalRequestsPage from "@/pages/ApprovalRequestsPage";
import ReportBuilderPage from "@/pages/ReportBuilderPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import CareersPage from "@/pages/CareersPage";
import VacancyPublicPage from "@/pages/VacancyPublicPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import AdminEmailsPage from "@/pages/AdminEmailsPage";
import WorkBoardsPage from "@/pages/WorkBoardsPage";
import WorkBoardDetailPage from "@/pages/WorkBoardDetailPage";
import SectorAutoGridPage from "@/pages/SectorAutoGridPage";
import OrgchartPage from "@/pages/OrgchartPage";
import WorkBoardReportPage from "@/pages/WorkBoardReportPage";
import ExecutiveDashboardPage from "@/pages/ExecutiveDashboardPage";
import AppraisalsPage from "@/pages/AppraisalsPage";
import PerformanceDashboardPage from "@/pages/PerformanceDashboardPage";
import TurnoverPage from "@/pages/TurnoverPage";
import AbsenteismoPage from "@/pages/AbsenteismoPage";
import AbsenceSituationsPage from "@/pages/AbsenceSituationsPage";
import EquipmentsPage from "@/pages/EquipmentsPage";
import HorasExtrasPage from "@/pages/HorasExtrasPage";
import BancoHorasPage from "@/pages/BancoHorasPage";
import ReportDesignerPage from "@/pages/ReportDesignerPage";
import SimuladorCltPjPage from "@/pages/SimuladorCltPjPage";
import SmartFormsPage from "@/pages/SmartFormsPage";
import PublicFormPage from "@/pages/PublicFormPage";
import SectorIndicatorsPage from "@/pages/SectorIndicatorsPage";
import SurveysPage from "@/pages/SurveysPage";
import SurveyResultsPage from "@/pages/SurveyResultsPage";
import SurveyPublicPage from "@/pages/SurveyPublicPage";
import PromotionLettersPage from "@/pages/PromotionLettersPage";
import PerformanceIndividualsPage from "@/pages/PerformanceIndividualsPage";
import PerformanceIndividualDetailPage from "@/pages/PerformanceIndividualDetailPage";
import OnboardingDashboardPage from "@/pages/OnboardingDashboardPage";
import OnboardingTemplatesPage from "@/pages/OnboardingTemplatesPage";
import OnboardingAssignPage from "@/pages/OnboardingAssignPage";
import OnboardingDetailPage from "@/pages/OnboardingDetailPage";
import NotificationsPage from "@/pages/NotificationsPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CompanyProvider>
          <ViewModeProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/f/:token" element={<PublicFormPage />} />
            <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
            <Route path="/reset-senha" element={<ResetPasswordPage />} />
            <Route path="/carreiras" element={<CareersPage />} />
            <Route path="/carreiras/:id" element={<VacancyPublicPage />} />
            <Route path="/p/pesquisa/:token" element={<SurveyPublicPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/diretoria" element={<ExecutiveDashboardPage />} />
              <Route path="/avaliacoes" element={<AppraisalsPage />} />
              <Route path="/performance" element={<PerformanceDashboardPage />} />
              <Route path="/performance/turnover" element={<TurnoverPage />} />
              <Route path="/performance/absenteismo" element={<AbsenteismoPage />} />
              <Route path="/admin/situacoes-absenteismo" element={<AbsenceSituationsPage />} />
              <Route path="/cadastros/equipamentos" element={<EquipmentsPage />} />
              <Route path="/operacional/horas-extras" element={<HorasExtrasPage />} />
              <Route path="/operacional/banco-horas" element={<BancoHorasPage />} />
              <Route path="/relatorios/designer" element={<ReportDesignerPage />} />
              <Route path="/simulador-clt-pj" element={<SimuladorCltPjPage />} />
              <Route path="/formularios" element={<SmartFormsPage />} />
              <Route path="/performance/setores" element={<SectorIndicatorsPage />} />
              <Route path="/performance/individuos" element={<PerformanceIndividualsPage />} />
              <Route path="/performance/individuos/:employeeId" element={<PerformanceIndividualDetailPage />} />
              <Route path="/performance/onboarding" element={<OnboardingDashboardPage />} />
              <Route path="/performance/onboarding/trilhas" element={<OnboardingTemplatesPage />} />
              <Route path="/performance/onboarding/atribuir" element={<OnboardingAssignPage />} />
              <Route path="/performance/onboarding/colaborador/:employeeId" element={<OnboardingDetailPage />} />
              <Route path="/notificacoes" element={<NotificationsPage />} />
              <Route path="/pesquisas" element={<SurveysPage />} />
              <Route path="/pesquisas/:sid/resultados" element={<SurveyResultsPage />} />
              <Route path="/cartas-promocao" element={<PromotionLettersPage />} />
              <Route path="/empresas" element={<CompaniesPage />} />
              {/* Unified hub (Sprint A · Item 1) */}
              <Route path="/setores-e-quadro" element={<SetoresEQuadroPage />} />
              {/* Legacy routes redirected to unified hub with matching tab */}
              <Route path="/setores" element={<Navigate to="/setores-e-quadro?tab=setores" replace />} />
              <Route path="/quadros-trabalho" element={<Navigate to="/setores-e-quadro?tab=quadros" replace />} />
              <Route path="/relatorios/quadro-trabalho" element={<Navigate to="/setores-e-quadro?tab=relatorio" replace />} />
              <Route path="/organograma" element={<Navigate to="/setores-e-quadro?tab=organograma" replace />} />
              <Route path="/colaboradores" element={<EmployeesPage />} />
              <Route path="/afastamentos" element={<EmployeeLeavesPage />} />
              <Route path="/cargos-salarios" element={<CargosSalariosPage />} />
              <Route path="/escalas" element={<SchedulesPage />} />
              <Route path="/quadros-trabalho/:id" element={<WorkBoardDetailPage />} />
              <Route path="/setores/:id/quadro" element={<SectorAutoGridPage />} />
              <Route path="/recrutamento" element={<RecruitmentPage />} />
              <Route path="/treinamentos" element={<TrainingsPage />} />
              <Route path="/desligamentos" element={<TerminationsPage />} />
              <Route path="/auditoria" element={<AuditPage />} />
              <Route path="/admin/usuarios" element={<AdminUsersPage />} />
              <Route path="/admin/permissoes" element={<ProtectedRoute roles={["master","rh_admin","diretoria"]}><PermissionsMatrixPage /></ProtectedRoute>} />
              <Route path="/admin/bloqueios" element={<ProtectedRoute roles={["master","rh_admin","diretoria"]} module="seguranca_auditoria"><AdminBlocksPage /></ProtectedRoute>} />
              <Route path="/admin/limpeza-base" element={<AdminCleanupPage />} />
              <Route path="/admin/metas" element={<ProtectedRoute roles={["master","rh_admin"]}><GoalsAdminPage /></ProtectedRoute>} />
              <Route path="/gestao-em-lote" element={<ProtectedRoute roles={["master","rh_admin"]}><BulkManagementPage /></ProtectedRoute>} />
              <Route path="/gestao-em-lote/historico" element={<ProtectedRoute roles={["master","rh_admin"]}><BulkHistoryPage /></ProtectedRoute>} />
              <Route path="/gestao-em-lote/aprovacoes" element={<ProtectedRoute roles={["master","rh_admin"]}><ApprovalRequestsPage /></ProtectedRoute>} />
              <Route path="/admin/integracoes" element={<IntegrationsPage />} />
              <Route path="/admin/emails" element={<ProtectedRoute roles={["master","rh_admin"]}><AdminEmailsPage /></ProtectedRoute>} />
              <Route path="/importacao" element={<ImportEmployeesPage />} />
              <Route path="/importacao-especifica" element={<SpecificImportPage />} />
              <Route path="/relatorios-ia" element={<AiReportsPage />} />
              <Route path="/relatorios-builder" element={<ReportBuilderPage />} />
              <Route path="/dashboard-grupo" element={<GroupDashboardPage />} />
              <Route path="/gestao" element={<GestaoPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
          </ViewModeProvider>
        </CompanyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
